import { useTranslation } from 'react-i18next';
import { CassetteReels } from '../cassette/CassetteReels';

/** Shown while a lazily loaded screen is on its way. */
export function RouteFallback() {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-dvh place-items-center" role="status" aria-live="polite">
      <div className="flex flex-col items-center gap-4">
        <CassetteReels spinning className="w-32" />
        <p className="text-sm text-ink-muted">{t('common.loading')}</p>
      </div>
    </div>
  );
}
